import { render, staticRenderFns } from "./UserPasswordAndPrivacy.vue?vue&type=template&id=1f0016d8"
import script from "./UserPasswordAndPrivacy.vue?vue&type=script&lang=js"
export * from "./UserPasswordAndPrivacy.vue?vue&type=script&lang=js"
import style0 from "./UserPasswordAndPrivacy.vue?vue&type=style&index=0&id=1f0016d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports